import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'moedaReal'
})
export class MoedaRealPipe implements PipeTransform {

  transform(value: number): string | null {
    if(value === undefined){
      return " - ";
    }
    return new Intl.NumberFormat('pt-BR', {style: 'currency', currency: 'BRL'}).format(value);
    }
}